<template>
    <div class="meet-the-team">
        <div class="meet-the-team__heading">{{ $t('common.microcopy.meet_the_team') }}</div>

        <div v-if="users" :class="usersClass">
            <div v-for="user in users" :key="user.id">
                <div v-if="user.firstName || user.lastName" class="meet-the-team__user">
                    <common-user-avatar
                        :user="user"
                        :shouldLeadToProfile="user?.showPublicProfile"
                        size="medium"
                        @avatar-click="onAvatarClick"
                    ></common-user-avatar>
                    <div class="meet-the-team__user-and-description">
                        <div>
                            <span>{{ user.firstName }} {{ user.lastName }}</span>
                        </div>
                        <div v-if="user?.descriptionTextContent?.originalText" class="meet-the-team__description">
                            {{ formatDescription(getTranslation(user?.descriptionTextContent)) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <user-preview-modal
            v-if="isPreviewUserModalOpen"
            :userPreview="userPreview"
            @close="closeUserPreviewModal"
        ></user-preview-modal>
    </div>
</template>

<script>
    import TranslateMixin from 'mixins/TranslateMixin'
    import UserPreviewModal from 'components/modals/user/UserPreviewModal'

    export default {
        mixins: [TranslateMixin],
        components: { UserPreviewModal },

        props: {
            users: { type: Array, default: () => new Array() },
            isVertical: { type: Boolean, default: false },
            sliceDescription: { type: Boolean, default: false },
        },

        data() {
            return {
                isPreviewUserModalOpen: false,
                userPreview: null,
            }
        },

        computed: {
            usersClass() {
                return {
                    'meet-the-team__users': true,
                    'meet-the-team__users--horizontal': !this.isVertical,
                }
            },
        },

        methods: {
            formatDescription(description) {
                if (description?.length < 50 || !this.sliceDescription) return description
                return `${description?.substring(0, 50)}...`
            },

            onAvatarClick(event) {
                if (!event.showPublicProfile) {
                    this.isPreviewUserModalOpen = true
                    this.userPreview = event
                }
            },

            closeUserPreviewModal() {
                this.isPreviewUserModalOpen = false
                this.userPreview = null
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/components/common/_meet-the-team.scss';
</style>
